import { render } from "./BranchChart.vue?vue&type=template&id=2baeefda"
import script from "./BranchChart.vue?vue&type=script&lang=js"
export * from "./BranchChart.vue?vue&type=script&lang=js"

import "./BranchChart.vue?vue&type=style&index=0&id=2baeefda&lang=scss"
script.render = render

export default script